import { render } from "./StorageManager.vue?vue&type=template&id=37b88a1b&ts=true"
import script from "./StorageManager.vue?vue&type=script&lang=ts"
export * from "./StorageManager.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__